import {JSX} from "react";

import Image from "next/image";

import {assetPath} from "@/shared/utils/asset-path";

import {LocationOption} from "../location-search.model";

export interface LocationSectionProps {
    title: string;
    options: ReadonlyArray<LocationOption>;
    selectedOptionId?: string;
    onOptionClick: (option: LocationOption) => void;
    sectionId: string;
}

export function LocationSection({title, options, selectedOptionId, onOptionClick, sectionId}: LocationSectionProps): JSX.Element | null {
    if (options.length === 0) return null;

    return (
        <div className="location-search-drawer__section" role="group" aria-labelledby={`${sectionId}-label`}>
            <div id={`${sectionId}-label`} className="location-search-drawer__section-title">
                {title}
            </div>
            {options.map((option) => (
                <div
                    key={option.id}
                    className="location-search-drawer__item"
                    onClick={() => onOptionClick(option)}
                    role="option"
                    aria-selected={selectedOptionId === option.id}
                    tabIndex={0}
                    onKeyDown={(e) => e.key === "Enter" && onOptionClick(option)}
                >
                    <span className="location-search-drawer__item-icon">
                        <Image src={assetPath("images/icons/location.svg")} alt="" width={24} height={24} />
                    </span>
                    <span className="location-search-drawer__item-text">{option.name}</span>
                </div>
            ))}
        </div>
    );
}
